export function tagClass(tag: string): string {
  switch (tag) {
    case '明星八卦':
      return 'border-primary-200 bg-primary-100 text-primary-800';
    case '网红黑料':
      return 'border-secondary-200 bg-secondary-100 text-secondary-900';
    case '热门事件':
      return 'border-accent-200 bg-accent-100 text-accent-900';
    case '今日吃瓜':
      return 'border-background-300/60 bg-background-200/70 text-foreground-700';
    default:
      return 'border-background-300/60 bg-background-200/70 text-foreground-700';
  }
}

export function dotClass(tag: string): string {
  switch (tag) {
    case '明星八卦':
      return 'bg-primary-500 border-primary-100';
    case '网红黑料':
      return 'bg-secondary-500 border-secondary-100';
    case '热门事件':
      return 'bg-accent-500 border-accent-100';
    default:
      return 'bg-foreground-400 border-background-200';
  }
}